import { AddressModel } from "./addressModel";
import { TopBrandModel } from "./topBrandModel";

export class ClientModel {
    public name!: string;
    public profile!: string;
    public addresses!: AddressModel[];
    public topBrands!: TopBrandModel[];
}